import React from 'react';
import './Hero.css';

const Hero = ({ onEnrollClick }) => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-pattern"></div>
      <div className="hero-content">
        <div className="logo-container">
          <img src="/logo.png" alt="Tesla's Academy Logo" />
        </div>
        <h1 className="hero-title">Tesla's Academy</h1>
        <p className="hero-tagline">Knowledge is Power</p>
        <p className="hero-description">
          Empowering students since 2015 with expert tuition for all standards (Grade I - XII) 
          and all syllabi (CBSE, Matric, IGCSE, ICSE, IB). Over 1000+ students successfully 
          guided to achieve their academic excellence across four branches in Tirupur and Coimbatore.
        </p>
        <button className="cta-button" onClick={onEnrollClick}>
          Enroll Now
        </button>
      </div>
      <div className="scroll-indicator">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 5v14M19 12l-7 7-7-7"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
